import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { sxModal } from './sxProps';
import './styles.css'
import { ErrorModalProps } from '../../../interfaces/props/SaudeOnline/ErrorModalProps';
import ErrorIcon from './ErrorIcon';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function HourErrorModal(props: ErrorModalProps) {

    const { fontSizeStyleAccessibility } = useAccessibility();

    const handleCloseModal = () => {
        props.handleCloseModal();
    }


    return (

        <div>
            <Modal
                open={props.open}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={sxModal}>
                    <div className="confirmation-feedback-modal-header">
                        <button style={fontSizeStyleAccessibility} className='confirmation-modal-header-close' onClick={handleCloseModal}><FontAwesomeIcon icon={faTimes} /></button>
                    </div>
                    <div className="confirmation-feedback-modal-info">
                        <ErrorIcon />
                    </div>
                    <h1 className="confirmation-feedback-modal-title" style={fontSizeStyleAccessibility}>
                        Atenção!
                    </h1>
                    <p className="confirmation-feedback-modal-message" style={fontSizeStyleAccessibility}>
                        Por favor, informe a data e horário do agendamento.
                    </p>
                </Box>
            </Modal>
        </div>
    );
}

export default HourErrorModal;